<template>
  <div class="result-expired">
    <!-- <SvgIcon color="#e6a23c" :size="112">f
      <path d="M512 0C229.2 0 0 229.2 0 512s229.2 512 512 512 512-229.3 512-512S794.8 0 512 0z" p-id="4220"></path>
      <path
        d="M512 832.7c-29.6 0-53.5-24-53.5-53.6s24-53.6 53.6-53.5c29.6 0 53.5 24 53.5 53.6 0 14.2-5.6 27.8-15.7 37.9-10.1 9.9-23.7 15.6-37.9 15.6zM561.7 258.5v369.7c0 33.2-16.6 49.7-49.7 49.7s-49.7-16.6-49.7-49.7V258.5c0-33.2 16.6-49.7 49.7-49.7 33.1-0.1 49.7 16.5 49.7 49.7z"
        fill="#FFFFFF" p-id="4221"></path>
    </SvgIcon> -->
    <img
      src="@/assets/images/mpesa/mpesaErreo.webp"
      class="image-center"
    />
    <p class="tips">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
import useOrderStore from '@/store/order'
import SvgIcon from 'components/svgIcon/index.vue'
import { computed } from 'vue'
const orderStore = useOrderStore()
const text = computed(
  () =>
    orderStore.expiredText ||
    `Your payment order has expired, please re-create the order. If you have any questions, please feel free to contact us.`
)
</script>
<style lang="scss" scoped>
.result-expired {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ebf2fc;
  background-size: 100% 100%;
  padding: 32px;
  padding-top: 64px;

  .tips {
    margin-top: 16px;
    line-height: 1.5;
    text-align: center;
    font-size: 16px;
  }
}
</style>
